import { render, staticRenderFns } from "./DashboardOnePage.vue?vue&type=template&id=479427b1&scoped=true"
import script from "./DashboardOnePage.vue?vue&type=script&lang=js"
export * from "./DashboardOnePage.vue?vue&type=script&lang=js"
import style0 from "./DashboardOnePage.vue?vue&type=style&index=0&id=479427b1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "479427b1",
  null
  
)

export default component.exports